<template>
    <div :id="target" class="modal fade" tabindex="-1">
        <div class="modal-dialog modal-width">
            <div class="modal-content">
                <div class="modal-header bg-ums">
                    <h5 class="modal-title">Send Test</h5>
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col">
                            <div class="card">
                                <div class="card-body">
                                    <legend class="text-uppercase font-size-sm font-weight-bold">Options</legend>
                                    <basic-input label="Recipient"
                                                 :vertical="true"
                                                 v-model="cloneData.recipient"
                                                 :rule="'required '+ (cloneData.msgType===$const.MSG_TYPE.SMS?'phone':'email')">
                                    </basic-input>
                                    <template v-for="(param,index) in cloneData.paramSubjects" >
                                        <div :key="target+'subjectSendParam'+index">
                                            <basic-input v-if="param.paramType === 'A'"
                                                         :label="'Parameter Subject'+param.paramKey+'-'+param.paramType"
                                                         type="number"  :vertical="true"
                                                         v-model="param.value"
                                                         :rule="makeRules(param)">

                                            </basic-input>
                                            <single-date-picker v-else-if="param.paramType === 'T' || param.paramType === 'H' || param.paramType === 'D'  || param.paramType === 'm'  || param.paramType === 'M'  || param.paramType === 'Y'"
                                                                :label="'Parameter Subject'+param.paramKey+'-'+param.paramType"
                                                                :vertical="true"
                                                                v-model="param.value" :rule="'required'">
                                            </single-date-picker>
                                            <basic-input v-else
                                                         :label="'Parameter Subject'+param.paramKey+'-'+param.paramType"
                                                         :vertical="true"
                                                         v-model="param.value"
                                                         :rule="makeRules(param)">

                                            </basic-input>
                                        </div>
                                    </template>
                                    <template v-for="(param,index) in cloneData.params" >
                                        <div :key="target+'testSend'+index">
                                            <basic-input v-if="param.paramType === 'A'"
                                                         :label="'Parameter'+param.paramKey+'-'+param.paramType"
                                                         type="number"  :vertical="true"
                                                         v-model="param.value"
                                                         :rule="makeRules(param)">

                                            </basic-input>
                                            <single-date-picker v-else-if="param.paramType === 'T' || param.paramType === 'H' || param.paramType === 'D'  || param.paramType === 'm'  || param.paramType === 'M'  || param.paramType === 'Y'"
                                                                :label="'Parameter'+param.paramKey+'-'+param.paramType"
                                                                :vertical="true"
                                                                v-model="param.value" :rule="'required'">
                                            </single-date-picker>
                                            <basic-input v-else
                                                         :label="'Parameter'+param.paramKey+'-'+param.paramType"
                                                         :vertical="true"
                                                         v-model="param.value"
                                                         :rule="makeRules(param)">

                                            </basic-input>
                                        </div>
                                    </template>
<!--                                    <basic-input label="Recursive"-->
<!--                                                 :vertical="true"-->
<!--                                                 type="number"-->
<!--                                                 v-model="recursiveCnt"-->
<!--                                                 rule="max:4">-->
<!--                                    </basic-input>-->
                                    <div><button class="btn btn-ums" style="width: 100%" @click="sendTest">Send</button></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import BasicInput from "@/components/form/input/BasicInput";
    import SingleDatePicker from "@/components/form/datepicker/SingeDatePicker";
    import validation from "@/config/mixin/validation";
    import api from "@/api/template"
    export default {
        name: "SendModal",
        components: {SingleDatePicker, BasicInput},
        mixins:[validation],
        props:{
            target:{
                type:String,
            },
            modalData: {

            }
        },
        data() {
            return {
                recursiveCnt:0,
                recipient:'',
                parameters: [],
                cloneData:{},
                sendData: {
                    lang: 'EN',
                    msgType: "1",
                    params: [],
                    paramSubjects: [],
                    userAdr: ""
                }
            }
        },
        mounted() {
        },
        methods: {
            sendTest: function() {
                if(!this.validationCheck()) return;
                this.setSendData()
                if(this.recursiveCnt) {
                    for(let i = 0; i<this.recursiveCnt; i++) {
                        console.log(this.$moment())
                        api.testMailSend(this.cloneData,this.sendData).then((result)=> {
                            console.log(result)
                        })
                    }
                } else {
                    if(this.cloneData.addParamSubjYn === "Y"){
                        console.log("VER 2")
                        api.testMailSendVer2(this.cloneData,this.sendData).then((result)=> {
                            if(result && result.data.code === 1000) {
                                this.$notify.success(result.data.message)
                                $('#'+this.target).modal('toggle')
                            }
                            else{
                                this.$notify.alert(result.data.message)
                                $('#'+this.target).modal('toggle')
                            }
                        })
                    }
                    else{
                        console.log("VER 1")
                        api.testMailSend(this.cloneData,this.sendData).then((result)=> {
                            if(result && result.data.code === 1000) {
                                this.$notify.success(result.data.message)
                                $('#'+this.target).modal('toggle')
                            } else {
                                this.$notify.alert(result.data.message)
                                $('#'+this.target).modal('toggle')
                            }
                        })
                    }
                }

            },
            setSendData: function() {
                this.sendData.lang = this.cloneData.lang
                this.sendData.msgType = this.cloneData.msgType
                this.sendData.userAdr = this.cloneData.recipient
                if(!this.cloneData.params || this.cloneData.params.length ===0 ){
                    this.sendData.params = []
                } else {
                    this.sendData.params = this.cloneData.params.reduce((base,row,idx,addr)=> {
                        let value = (row.paramKey+':'+row.paramType+':'+(row.value?row.value:''))
                        base = [...base,value]
                        return base
                    },[])
                }
                if(!this.cloneData.paramSubjects || this.cloneData.paramSubjects.length ===0 ){
                    this.sendData.paramSubjects = []
                }else {
                    this.sendData.paramSubjects = this.cloneData.paramSubjects.reduce((base,row,idx,addr)=> {
                        let value = (row.paramKey+':'+row.paramType+':'+(row.value?row.value:''))
                        base = [...base,value]
                        return base
                    },[])
                }
            },
            makeRules: function(param) {
                let rules = ['required']
                if(this.cloneData.msgType === this.$const.MSG_TYPE.SMS) {
                    if(param.paramLen) rules.push('max:' + param.paramLen)
                }
                return rules.join(' ')
            }
        },
        watch: {
            'modalData':function(val){
                this.cloneData = $.extend(true,{},val)
            }
        }

    }
</script>

<style scoped>
    .modal-header .close {
        top:4% !important;
    }
    .modal-header {
        padding: 9px 19px !important;
    }
    .modal-width {
        max-width: 724px;
    }
</style>
